import { dialerServiceClient } from "@/api/dialerServiceClient";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
import { DialStatsReq } from "@/pbjs/xcommon/dialer_pb";
// lee 绩效接口参数
interface Options {
  pickDate?: string; // 查询时间范围
  supplier?: string;  // 供应商
  extNumber?: string; // 分机号
  user?: string; // 员工姓名
  userID?:string;  // 员工编号
  roleIDs?: string; // 角色ID
  itemID?: string; // 工单类型
  dimension?: any; // 查询维度
  pageIndex: number;
  pageSize: number;
}
export function dialStats(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialStatsReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDate(arg.pickDate);
      request.setSupplier(arg.supplier);
      request.setExtnumber(arg.extNumber);
      request.setUser(arg.user);
      request.setUserid(arg.userID);
      request.setRoleids(arg.roleIDs);
      request.setItemid(arg.itemID);
      request.setDimensionList(arg.dimension);
      // setRank
      let _res = await dialerServiceClient.dialStats(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function downloadcallRecordExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialStatsReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDate(arg.pickDate);
      request.setSupplier(arg.supplier);
      request.setExtnumber(arg.extNumber);
      request.setUser(arg.user);
      request.setRoleids(arg.roleIDs);
      request.setItemid(arg.itemID);
      request.setDimensionList(arg.dimension);
      // setRank
      let _res = await dialerServiceClient.dialStatsExport(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            // const res: any = response.toObject();
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function dialStatsHour(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialStatsReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDate(arg.pickDate);
      request.setUser(arg.user);
      request.setRoleids(arg.roleIDs);
      request.setItemid(arg.itemID);
      request.setExtnumber(arg.extNumber);
      request.setSupplier(arg.supplier);
      request.setDimensionList(arg.dimension);
      request.setUserid(arg.userID);
      // setRank
      let _res = await dialerServiceClient.dialHourlyStats (
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function downloadcallRecordHourExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new DialStatsReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      request.setDate(arg.pickDate);
      request.setSupplier(arg.supplier);
      request.setExtnumber(arg.extNumber);
      request.setUser(arg.user);
      request.setRoleids(arg.roleIDs);
      request.setItemid(arg.itemID);
      request.setDimensionList(arg.dimension);
      // setRank
      let _res = await dialerServiceClient.dialHourlyStatsExport(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            // const res: any = response.toObject();
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
